import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import Sign from '~/pages/Sign';

export default function Routes() {
  return (
    <Switch>
      <Route exact path="/" component={Sign} />
      <Route path="*">
        <Redirect to="/" />
      </Route>
    </Switch>
  );
}
